var _rect, _rect2, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconType3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#5BCBC9",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2852,
    y: 17.2988,
    width: 15.4286,
    height: 9.11688,
    rx: 2,
    fill: "#5BCBC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.792 10.6364C13.792 10.0554 14.263 9.58447 14.8439 9.58447C15.4249 9.58447 15.8959 10.0554 15.8959 10.6364V12.039C15.8959 12.62 15.4249 13.091 14.8439 13.091C14.263 13.091 13.792 12.62 13.792 12.039V10.6364Z",
    fill: "#5BCBC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1035 10.6364C20.1035 10.0554 20.5745 9.58447 21.1555 9.58447C21.7364 9.58447 22.2074 10.0554 22.2074 10.6364V12.039C22.2074 12.62 21.7364 13.091 21.1555 13.091C20.5745 13.091 20.1035 12.62 20.1035 12.039V10.6364Z",
    fill: "#5BCBC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7007 11.6885H17.2981V12.0391C17.2981 13.3947 16.1992 14.4937 14.8436 14.4937C13.488 14.4937 12.3891 13.3947 12.3891 12.0391V11.6885H12.2852C11.1806 11.6885 10.2852 12.5839 10.2852 13.6885V13.8963C10.2852 15.0008 11.1806 15.8963 12.2852 15.8963H23.7137C24.8183 15.8963 25.7137 15.0008 25.7137 13.8963V13.6885C25.7137 12.5839 24.8183 11.6885 23.7137 11.6885H23.6098V12.0391C23.6098 13.3947 22.5109 14.4937 21.1553 14.4937C19.7997 14.4937 18.7007 13.3947 18.7007 12.0391V11.6885ZM20.1033 11.6885V12.0391C20.1033 12.6201 20.5743 13.0911 21.1553 13.0911C21.7363 13.0911 22.2072 12.6201 22.2072 12.0391V11.6885H20.1033ZM13.7916 12.0391V11.6885H15.8955V12.0391C15.8955 12.6201 15.4246 13.0911 14.8436 13.0911C14.2626 13.0911 13.7916 12.6201 13.7916 12.0391Z",
    fill: "#5BCBC9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconType3);
export default __webpack_public_path__ + "static/media/icon-type-3.4769671d.svg";
export { ForwardRef as ReactComponent };